import { TCypher } from '@sifrovacihra/shared-ui'

export const cyphers2021: Array<TCypher> = [
    {
        Id: 1,
        name: "Pravidla",
        url: "https://sift.sifrovacihra.cz/2021/1-pravidla-web.pdf",
        helps: [{
            help: "V každé větě je název šifrovačky, spočítáte, jako kolikáté slovo?"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2021/1-pravidla-reseni.pdf",
        }

    },
    {
        Id: 2,
        name: "Slovník",
        url: "https://sift.sifrovacihra.cz/2021/2-slovnik-web.pdf",
        helps: [{
            help: "Přelož písmenka z angličtiny do češtiny."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2021/2-slovnik-reseni.pdf",
        }
    },
    {
        Id: 3,
        name: "Příhody",
        url: "https://sift.sifrovacihra.cz/2021/3-prihody-web.pdf",
        helps: [{
            help: "Jedno písmenko názvu knihy odpovídá jednomu písmenku ve větě."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2021/3-prihody-reseni.pdf",
        }
    },
    {
        Id: 4,
        name: "Bez Q",
        url: "https://sift.sifrovacihra.cz/2021/4-bezQ-web.pdf",
        helps: [{
            help: "Abecedu si napište do mřížky 5x5, písmeno Q vynechte."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2021/4-bezQ-reseni.pdf",
        }
    },
    {
        Id: 5,
        name: "Obrázky",
        url: "https://sift.sifrovacihra.cz/2021/5-obrazky-web.pdf",
        helps: [{
            help: "Obrázků v šifře není náhodný počet a navíc jsou chronologicky seřazené. Pojmenujte si je!"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2021/5-obrazky-reseni.pdf",
        }
    },
    {
        Id: 6,
        name: "Cílové heslo",
        url: "https://sift.sifrovacihra.cz/2021/6-ciloveHeslo-web.pdf",
        helps: [{
            help: "Cílové heslo se nejlépe luští před vstupem do knihovny."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2021/6-ciloveHeslo-reseni.pdf",
        }
    }
]

export const cyphers2022: Array<TCypher> = [
    {
        Id: 1,
        name: "Domino",
        url: "https://sift.sifrovacihra.cz/2022/1-domino-web.pdf",
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2022/1-domino-reseni.pdf",
        }
    },
    {
        Id: 2,
        name: "Řeky",
        url: "https://sift.sifrovacihra.cz/2022/2-reky-web.pdf",
        helps: [{
            help: "Kde se řeky stékají?"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2022/2-reky-reseni.pdf",
        }
    },
    {
        Id: 3,
        name: "Rozhovor",
        url: "https://sift.sifrovacihra.cz/2022/3-rozhovor-web.pdf",
        helps: [{
            help: "Zmíněná místa v mapě jsou označena nějakým bodem nebo čárou."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2022/3-rozhovor-reseni.pdf",
        }
    },
    {
        Id: 4,
        name: "Chlívečky",
        url: "https://sift.sifrovacihra.cz/2022/4-chlivecky-web.pdf",
        helps: [{
            help: "Přidávejte/ubírejte tečky a čárky zleva/zprava"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2022/4-chlivecky-reseni.pdf",
        }
    },
    {
        Id: 5,
        name: "Souměrnosti",
        url: "https://sift.sifrovacihra.cz/2022/5-soumernosti-web.pdf",
        helps: [{
            help: "Doplňte středy a osy souměrnosti"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2022/5-soumernosti-reseni.pdf",
        }
    },
    {
        Id: 6,
        name: "Criss-cross",
        url: "https://sift.sifrovacihra.cz/2022/6-crissCross-web.pdf",
        helps: [{
            help: "Dopňujte od akátu po známou ženu"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2022/6-crissCross-reseni.pdf",
        }
    },
    {
        Id: 7,
        name: "Téma",
        url: "https://sift.sifrovacihra.cz/2022/7-tema-web.pdf",
        helps: [{
            help: "Aplikuj na šifru chemickou sloučeninu vodíku a kyslíku."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2022/7-tema-reseni.pdf",
        }
    }
]

export const cyphers2023: Array<TCypher> = [
    {
        Id: 1,
        name: "Hra",
        url: "https://sift.sifrovacihra.cz/2023/1-hra.pdf",
        helps: [{
            help: "Nápovědy se vydávaly na startu. První nápovědou byla hrací deska na Scrabble, druhou pak doplněné zadání o hodnoty písmen ve Scrabble."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2023/1-hra-reseni.pdf",
        }
    },
    {
        Id: 2,
        name: "Letokruhy",
        url: "https://sift.sifrovacihra.cz/2023/2-letokruhy.pdf",
        helps: [{
            help: "Vidíte v zadání 20 písmen řešení nebo jste snad slepí? Čtěte od nejmenšího průměru."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2023/2-letokruhy-reseni.pdf",
        }
    },
    {
        Id: 3,
        name: "Písnička",
        url: "https://sift.sifrovacihra.cz/2023/3-pisnicka.pdf",
        helps: [{
            help: "Běží liška k Táboru."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2023/3-pisnicka-reseni.pdf",
        }
    },
    {
        Id: 4,
        name: "Doplňovačka",
        url: "https://sift.sifrovacihra.cz/2023/4-doplnovacka.pdf",
        helps: [{
            help: "P má v morseovce celkem 4 znaky, O celkem 3 znaky a K také celkem 3 znaky. První písmenko tajenky je O."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2023/4-doplnovacka-reseni.pdf",
        }
    },
    {
        Id: 5,
        name: "Fotbal",
        url: "https://sift.sifrovacihra.cz/2023/5-fotbal.pdf",
        helps: [{
            help: "Na konci slovního fotbalu mág vstřelí gól a poslepu přečte písmenko tajenky."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2023/5-fotbal-reseni.pdf",
        }
    },
    {
        Id: 6,
        name: "Kompas",
        url: "https://sift.sifrovacihra.cz/2023/6-kompas.pdf",
        helps: [{
            help: "Každá barva na kompasu vykreslí jedno písmenko."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2023/6-kompas-reseni.pdf",
        }
    },
    {
        Id: 7,
        name: "Heslo",
        url: "https://sift.sifrovacihra.cz/2023/7-heslo-web.pdf",
        helps: [{
            help: "Pořádně se podívejte na druhou stranu zadání."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2023/7-heslo-reseni.pdf",
        }
    },
]

export const cyphers2024Z: Array<TCypher> = [
    {
        Id: 1,
        name: "Start",
        url: "https://sift.sifrovacihra.cz/2024/Z1-start.pdf",
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/Z1-start-reseni.pdf",
        }
    },
    {
        Id: 2,
        name: "Zvířátka",
        url: "https://sift.sifrovacihra.cz/2024/Z2-zviratka.pdf",
        helps: [{
            help: "Pojmenujte zvířátka a přečtěte zvýrazněná písmenka."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/Z2-zviratka-reseni.pdf",
        }
    },
    {
        Id: 3,
        name: "Křížovka",
        url: "https://sift.sifrovacihra.cz/2024/Z3-krizovka.pdf",
        helps: [{
            help: "Zvuky nahraďte jmény."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/Z3-krizovka-reseni.pdf",
        }
    },
    {
        Id: 4,
        name: "Mutanti",
        url: "https://sift.sifrovacihra.cz/2024/Z4-mutanti.pdf",
        helps: [{
            help: "Najděte přebývající písmenka."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/Z4-mutanti-reseni.pdf",
        }
    },
    {
        Id: 5,
        name: "Les",
        url: "https://sift.sifrovacihra.cz/2024/Z5-les.pdf",
        helps: [{
            help: "Ve větě: Máslo není! se SLON schovává za Á."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/Z5-les-reseni.pdf",
        }
    },
    {
        Id: 6,
        name: "Hřbitov",
        url: "https://sift.sifrovacihra.cz/2024/Z6-hrbitov.pdf",
        helps: [{
            help: "Seřaďte hroby podle úmrtí."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2023/Z6-hrbitov-reseni.pdf",
        }
    },
    {
        Id: 7,
        name: "Stopy",
        url: "https://sift.sifrovacihra.cz/2024/Z7-stopy.pdf",
        helps: [{
            help: "Koukněte do mapy centra Tábora."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/Z7-stopy-reseni.pdf",
        }
    },
    {
        Id: 8,
        name: "Mřížka",
        url: "https://sift.sifrovacihra.cz/2024/Z8-mrizka.pdf",
        helps: [{
            help: "Použijte startovní šifru."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/Z8-mrizka-reseni.pdf",
        }
    },
]

export const cyphers2024P: Array<TCypher> = [
    {
        Id: 1,
        name: "Start",
        url: "https://sift.sifrovacihra.cz/2024/P1-start.pdf",
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P1-start-reseni.pdf",
        }
    },
    {
        Id: 2,
        name: "Zvířátka",
        url: "https://sift.sifrovacihra.cz/2024/P2-zviratka.pdf",
        helps: [{
            help: "Počet písmen ve jménu zvířete je z obrázku poznat."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P2-zviratka-reseni.pdf",
        }
    },
    {
        Id: 3,
        name: "Křížovka",
        url: "https://sift.sifrovacihra.cz/2024/P3-krizovka.pdf",
        helps: [{
            help: "Kdo se to ozývá?"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P3-krizovka-reseni.pdf",
        }
    },
    {
        Id: 4,
        name: "Mutanti",
        url: "https://sift.sifrovacihra.cz/2024/P4-mutanti.pdf",
        helps: [{
            help: "Najděte přebývající písmenka."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P4-mutanti-reseni.pdf",
        }
    },
    {
        Id: 5,
        name: "Les",
        url: "https://sift.sifrovacihra.cz/2024/P5-les.pdf",
        helps: [{
            help: "Ve větě: Máslo není! se schovává SLON. Za čím bezprostředně?"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P5-les-reseni.pdf",
        }
    },
    {
        Id: 6,
        name: "Hřbitov",
        url: "https://sift.sifrovacihra.cz/2024/P6-hrbitov.pdf",
        helps: [{
            help: "Seřaďte hroby podle úmrtí."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P6-hrbitov-reseni.pdf",
        }
    },
    {
        Id: 7,
        name: "Zajímavosti",
        url: "https://sift.sifrovacihra.cz/2024/P7-zajimavosti.pdf",
        helps: [{
            help: "Nahraďte pořadovou číslici písmenem tajenky."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P7-mrizka-reseni.pdf",
        }
    },
    {
        Id: 8,
        name: "Proužky",
        url: "https://sift.sifrovacihra.cz/2024/P8-prouzky.pdf",
        helps: [{
            help: "Použij nůžky a úhloměr."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P8-prouzky-reseni.pdf",
        }
    },
    {
        Id: 9,
        name: "Stopy",
        url: "https://sift.sifrovacihra.cz/2024/P9-stopy.pdf",
        helps: [{
            help: "Koukněte do mapy centra Tábora."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P9-stopy-reseni.pdf",
        }
    },
    {
        Id: 10,
        name: "Mřížka",
        url: "https://sift.sifrovacihra.cz/2024/P10-mrizka.pdf",
        helps: [{
            help: "Použijte tabulku, kterou jste dostali již dříve."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2024/P10-mrizka-reseni.pdf",
        }
    },
]

export const cyphers2025Z: Array<TCypher> = [
    {
        Id: 0,
        name: "Startovní šifřičky",
        url: "https://sift.sifrovacihra.cz/2025/Z0-start-sifricky.pdf",
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/Z0-start-sifricky-reseni.pdf",
        }
    },
    {
        Id: 1,
        name: "Start",
        url: "https://sift.sifrovacihra.cz/2025/Z1-start.pdf",
        helps: [{
            help: "Každý čtverec sestavte ze všech 4 různých čtverečků, co jste dostali za řešení startovních šifřiček."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/Z1-start-reseni.pdf",
        },
        stars: 5.0,
        votes: 9,
    },
    {
        Id: 2,
        name: "Jako",
        url: "https://sift.sifrovacihra.cz/2025/Z2-jako.pdf",
        helps: [{
            help: "Pilně jako včelky čtěte písmenka z přirovnání."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/Z2-jako-reseni.pdf",
        },
        stars: 4.833333,
        votes: 6,
    },
    {
        Id: 3,
        name: "Mřížka",
        url: "https://sift.sifrovacihra.cz/2025/Z3-mrizka.pdf",
        helps: [{
            help: "Umístěte písmenka do mřížky."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/Z3-mrizka-reseni.pdf",
        },
        stars: 4.714285,
        votes: 7,
    },
    {
        Id: 4,
        name: "Spojovací",
        url: "https://sift.sifrovacihra.cz/2025/Z4-spojovaci.pdf",
        helps: [{
            help: "Začněte tím, že pospojujete postupně čísla od 1 do 27 rovnými čarami."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/Z4-spojovaci-reseni.pdf",
        },
        stars: 4.833333,
        votes: 6,
    },
    {
        Id: 5,
        name: "Stopy",
        url: "https://sift.sifrovacihra.cz/2025/Z5-stopy.pdf",
        helps: [{
            help: "Doplňte jména zvířat."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/Z5-stopy-reseni.pdf",
        },
        stars: 4.571428,
        votes: 7,
    },
    {
        Id: 6,
        name: "Hadi",
        url: "https://sift.sifrovacihra.cz/2025/Z6-hadi.pdf",
        helps: [{
            help: "Projděte cestu od 1 do 100, žebříky posouvají nahoru, hadi zase dolu."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/Z6-hadi-reseni.pdf",
        },
        stars: 4.833333,
        votes: 6,
    },
    {
        Id: 7,
        name: "Řada",
        url: "https://sift.sifrovacihra.cz/2025/Z7-rada.pdf",
        helps: [{
            help: "Nejprve si napište 26 člennou řadu anglické abecedy."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/Z7-rada-reseni.pdf",
        },
        stars: 4.857142,
        votes: 7,
    }
]

export const cyphers2025P: Array<TCypher> = [
    {
        Id: 0,
        name: "Startovní šifřičky",
        url: "https://sift.sifrovacihra.cz/2025/P0-start-sifricky.pdf",
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P0-start-sifricky-reseni.pdf",
        }
    },
    {
        Id: 1,
        name: "Start",
        url: "https://sift.sifrovacihra.cz/2025/P1-start.pdf",
        helps: [{
            help: "Sestavte 4 čtverce k sobě přiložením červených písmen."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P1-start-reseni.pdf",
        },
        stars: 3.75,
        votes: 4,
    },
    {
        Id: 2,
        name: "Čtverce",
        url: "https://sift.sifrovacihra.cz/2025/P2-ctverce.pdf",
        helps: [{
            help: "Použijte čtverce ze startu."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P2-ctverce-reseni.pdf",
        },
        stars: 4.2,
        votes: 5,
    },
    {
        Id: 3,
        name: "Věty",
        url: "https://sift.sifrovacihra.cz/2025/P3-vety.pdf",
        helps: [{
            help: "Kolik písmen Q je v 17. větě?"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P3-vety-reseni.pdf",
        },
        stars: 4.2,
        votes: 5,
    },
    {
        Id: 4,
        name: "Příklady",
        url: "https://sift.sifrovacihra.cz/2025/P4-priklady.pdf",
        helps: [{
            help: "Oindexujte si Řádky a Sloupce, doplníte tak zadání sudoku."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P4-priklady-reseni.pdf",
        },
        stars: 3.8,
        votes: 5,
    },
    {
        Id: 5,
        name: "Spojovací",
        url: "https://sift.sifrovacihra.cz/2025/P5-spojovaci.pdf",
        helps: [{
            help: "Máte obě části zadání? Pokud ne, dojděte si na druhou stranu řeky. Pokud ano, spojte úsečkou stejná čísla."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P5-spojovaci-reseni.pdf",
        },
        stars: 4.6,
        votes: 5,
    },
    {
        Id: 6,
        name: "Čísla",
        url: "https://sift.sifrovacihra.cz/2025/P6-cisla.pdf",
        helps: [{
            help: "Co mají společného TRI, CTYRI, PET, DEVET, STO a TISIC?"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P6-cisla-reseni.pdf",
        },
        stars: 4.25,
        votes: 4,
    },
    {
        Id: 7,
        name: "Hadi",
        url: "https://sift.sifrovacihra.cz/2025/P7-hadi.pdf",
        helps: [{
            help: "Každý žebřík i had dává substituci písmene na jeho začátku za písmeno na jeho konci."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P7-hadi-reseni.pdf",
        },
        stars: 4.0,
        votes: 4,
    },
    {
        Id: 8,
        name: "Kapličky",
        url: "https://sift.sifrovacihra.cz/2025/P8-kaplicky.pdf",
        helps: [{
            help: "Koukněte na pořadí prvních 7 zastavení křížové cesty Klokoty a následně si tuto část cesty poskládejte."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P8-kaplicky-reseni.pdf",
        },
        stars: 3.333333,
        votes: 3,
    },
    {
        Id: 9,
        name: "Abeceda",
        url: "https://sift.sifrovacihra.cz/2025/P9-abeceda.pdf",
        helps: [{
            help: "Na začátku máme řadu 26 písmen abecedy a postupně z ní čteme a vyškrtáváme."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2025/P9-abeceda-reseni.pdf",
        },
        stars: 4.333333,
        votes: 3,
    }
]

export const cyphers2026Z: Array<TCypher> = [
    {
        Id: 0,
        name: "Startovní šifřičky",
        url: "https://sift.sifrovacihra.cz/2026/Z0-sifricky.pdf",
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/Z0-sifricky-reseni.pdf",
        }
    },
    {
        Id: 1,
        name: "Start",
        url: "https://sift.sifrovacihra.cz/2026/Z1-start.pdf",
        helps: [{
            help: "Řešení startovních šifřiček: BULDOZERISTKA, CYKLOHEXAN, CENTRIFUGA, ADJEKTIVUM, figurka s písmenem P bude umístěna vpravo dole, tajenku čtěte na černé lince."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/Z1-start-reseni.pdf",
        },
        stars: 5,
        votes: 5,
    },
    {
        Id: 2,
        name: "Mřížka",
        url: "https://sift.sifrovacihra.cz/2026/Z2-mrizka.pdf",
        helps: [{
            help: "Na startu jste rozestavili figurky do mřížky 6x4"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/Z2-mrizka-reseni.pdf",
        },
        stars: 5,
        votes: 3,
    },
    {
        Id: 3,
        name: "Stíny",
        url: "https://sift.sifrovacihra.cz/2026/Z3-stiny.pdf",
        helps: [{
            help: "KOčka leze dírou, pEs oknem"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/Z3-stiny-reseni.pdf",
        },
        stars: 4.6,
        votes: 5,
    },
    {
        Id: 4,
        name: "Hody",
        url: "https://sift.sifrovacihra.cz/2026/Z4-hody.pdf",
        helps: [{
            help: "Člověče, nezlob se a vytáhni z batohu figurky. Kuk na vyhozené!"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/Z4-hody-reseni.pdf",
        },
        stars: 4,
        votes: 3,
    },
    {
        Id: 5,
        name: "Tečky",
        url: "https://sift.sifrovacihra.cz/2026/Z5-tecky.pdf",
        helps: [{
            help: "Vyberte písmenko z názvu n-úhelníku"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/Z5-tecky-reseni.pdf",
        },
        stars: 4.6,
        votes: 3,
    },
    {
        Id: 6,
        name: "Písmenka",
        url: "https://sift.sifrovacihra.cz/2026/Z6-pismenka.pdf",
        helps: [{
            help: "Písmenka si hodila kostkou a popošla dopředu"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/Z6-pismenka-reseni.pdf",
        },
        stars: 3.2,
        votes: 5,
    },
    {
        Id: 7,
        name: "Dílky",
        url: "https://sift.sifrovacihra.cz/2026/Z7-dilky.pdf",
        helps: [{
            help: "Tajenku čtěte na stěnách hrací kostky"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/Z7-dilky-reseni.pdf",
        },
        stars: 4,
        votes: 3,
    },
]
export const cyphers2026P: Array<TCypher> = [
    {
        Id: 0,
        name: "Startovní šifřičky",
        url: "https://sift.sifrovacihra.cz/2026/P0-sifricky.pdf",
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P0-sifricky-reseni.pdf",
        }
    },
    {
        Id: 1,
        name: "Start",
        url: "https://sift.sifrovacihra.cz/2026/P1-start.pdf",
        helps: [{
            help: "Řešení startovních šifřiček: BULDOZERISTKA, CYKLOHEXAN, CENTRIFUGA, ADJEKTIVUM, figurka s písmenem P bude umístěna vpravo dole, tajenku čtěte na černé lince."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P1-start-reseni.pdf",
        },
        stars: 4.6,
        votes: 5,
    },
    {
        Id: 2,
        name: "Mřížka",
        url: "https://sift.sifrovacihra.cz/2026/P2-mrizka.pdf",
        helps: [{
            help: "Na startu jste rozestavili figurky do mřížky 6x4"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P2-mrizka-reseni.pdf",
        },
        stars: 4,
        votes: 5,
    },
    {
        Id: 3,
        name: "Stíny",
        url: "https://sift.sifrovacihra.cz/2026/P3-stiny.pdf",
        helps: [{
            help: "KOčka leze dírou, pEs oknem"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P3-stiny-reseni.pdf",
        },
        stars: 4.2,
        votes: 5,
    },
    {
        Id: 4,
        name: "Hody",
        url: "https://sift.sifrovacihra.cz/2026/P4-hody.pdf",
        helps: [{
            help: "Člověče, nezlob se a vytáhni z batohu figurky"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P4-hody-reseni.pdf",
        },
        stars: 4.2,
        votes: 5,
    },
    {
        Id: 5,
        name: "Tečky",
        url: "https://sift.sifrovacihra.cz/2026/P5-tecky.pdf",
        helps: [{
            help: "Vyberte písmenko z názvu n-úhelníku, nezapomeň barevně seřadit!"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P5-tecky-reseni.pdf",
        },
        stars: 2.4,
        votes: 5,
    },
    {
        Id: 6,
        name: "Písmenka",
        url: "https://sift.sifrovacihra.cz/2026/P6-pismenka.pdf",
        helps: [{
            help: "Písmenka si hodila kostkou a popošla dopředu"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P6-pismenka-reseni.pdf",
        },
        stars: 2.6,
        votes: 5,
    },
    {
        Id: 7,
        name: "Čtverce",
        url: "https://sift.sifrovacihra.cz/2026/P7-ctverce.pdf",
        helps: [{
            help: "Na startu jse rozestavili figurky do 26 čtverců"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P7-ctverce-reseni.pdf",
        },
        stars: 3.8,
        votes: 7,
    },
    {
        Id: 8,
        name: "Posloupnost",
        url: "https://sift.sifrovacihra.cz/2026/P8-posloupnost.pdf",
        helps: [{
            help: "Šifru tvoří 8 posloupností, všechny začínají od svého prvního prvku."
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P8-posloupnost-reseni.pdf",
        },
        stars: 2.6,
        votes: 8,
    },
    {
        Id: 9,
        name: "Dílky",
        url: "https://sift.sifrovacihra.cz/2026/P9-dilky.pdf",
        helps: [{
            help: "Tajenku čtěte na stěnách hrací kostky"
        }],
        solutionUrl: {
            url: "https://sift.sifrovacihra.cz/2026/P9-dilky-reseni.pdf",
        },
        stars: 4.8,
        votes: 6,
    },
]
